import React, { ReactElement } from 'react';
import { Field } from 'formik';

import s from './publicForm.module.scss';
import TrackableLink from '../TrackableLink';

interface DsgvoProps {
  error: string | null;
}

export default function Dsgvo(props: DsgvoProps): ReactElement {
  const { error } = props;
  return (
    <div className={`${s.formGroup} ${s.checkbox}`}>
      <Field type="checkbox" name="dsgvo" />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor="dsgvo">
        <div>
          {'Ja, ich bin mit der Verarbeitung meiner Daten und den '}
          <TrackableLink to="/datenschutz">
            Datenschutzbestimmungen
          </TrackableLink>{' '}
          einverstanden.
        </div>
      </label>
      {error && <div className={s.error}>{error}</div>}
    </div>
  );
}
